import PencilSquare from './PencilSquare';

export default PencilSquare;
